import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    progress: {
      marginTop: theme.spacing(1),
    },
    infiniteScroll: {
      overflow: 'hidden',
    },
    item: {
      padding: theme.spacing(1, 0),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(1),
      },
    },
  })
);
